"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaBreakpoint = void 0;
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const useMediaBreakpoint = () => {
    const [isSmallScreen, setIsSmallScreenState] = (0, react_1.useState)(() => window.matchMedia(ui_react_1.Theme.mediaBreakpoints.small).matches);
    const [isMobile, setIsMobileState] = (0, react_1.useState)(() => window.matchMedia(ui_react_1.Theme.mediaBreakpoints.xsmall).matches);
    (0, react_1.useEffect)(() => {
        const smallBreakpoint = window.matchMedia(ui_react_1.Theme.mediaBreakpoints.small);
        const xsmallBreakpoint = window.matchMedia(ui_react_1.Theme.mediaBreakpoints.xsmall);
        const handleSmallScreenChange = (e) => setIsSmallScreenState(e.matches);
        const handleMobileChange = (e) => {
            setIsMobileState(e.matches);
        };
        smallBreakpoint.addEventListener('change', handleSmallScreenChange);
        xsmallBreakpoint.addEventListener('change', handleMobileChange);
        return () => {
            smallBreakpoint.removeEventListener('change', handleSmallScreenChange);
            xsmallBreakpoint.removeEventListener('change', handleMobileChange);
        };
    }, []);
    return {
        isSmallScreen,
        isMobile,
    };
};
exports.useMediaBreakpoint = useMediaBreakpoint;
//# sourceMappingURL=use_media_breakpoint.js.map